import Overlay from 'mini-overlay/lib/components/Overlay';
import React from 'react';
import strings from 'owa-strings/owa-mini-strings';
import { AccessibilityAnchorButton } from 'mini-accessibility';
import { ModalProps } from '../schema/ModalProps';

const styles = require('./Modal.scss');

/**
 * Component which renders the jsx element passed as props in the bottom sheet
 */
export const Modal: React.FC<ModalProps> = React.forwardRef((props, ref?: React.RefObject<any>) => {
    const { children, onOverlayClick, addAccessibleCloseButton = true } = props;

    return (
        <div className={styles.modalContainer}>
            <Overlay onClick={onOverlayClick} className={styles.modalOverlay} />
            <div ref={ref} className={styles.modalContentContainer}>
                {children}
            </div>
            {addAccessibleCloseButton && onOverlayClick && (
                <AccessibilityAnchorButton label={strings.closeDialog} onClick={onOverlayClick} />
            )}
        </div>
    );
});
